import { render, staticRenderFns } from "./PrivacyBanner.vue?vue&type=template&id=59529570&scoped=true&"
import script from "./PrivacyBanner.vue?vue&type=script&lang=ts&"
export * from "./PrivacyBanner.vue?vue&type=script&lang=ts&"
import style0 from "./PrivacyBanner.vue?vue&type=style&index=0&id=59529570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59529570",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('59529570', component.options)
    } else {
      api.reload('59529570', component.options)
    }
    module.hot.accept("./PrivacyBanner.vue?vue&type=template&id=59529570&scoped=true&", function () {
      api.rerender('59529570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/global/PrivacyBanner.vue"
export default component.exports